import React from 'react';

import { CustomLoader } from '../CustomLoader';
import { Logo } from '../Logo';
import { styled } from '@material-ui/styles';
import { Stack } from 'Web/Components/Widgets/Stack';

export const LoadingPage = () => {
    return (
        <Container>
            <Logo style={{ marginBottom: '24px' }} />
            <CustomLoader darkColor />
        </Container>
    );
};

const Container = styled(Stack)({
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    backgroundColor: '#ffffff',
});
